import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  onClick,
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'font-medium rounded-ios transition-all active:scale-95 flex items-center justify-center gap-2';
  const variantStyles = {
    primary: 'bg-dark-green text-white shadow-ios active:shadow-none',
    secondary: 'bg-white text-dark-green border-2 border-dark-green',
    ghost: 'bg-transparent text-dark-green'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm min-h-[36px]',
    md: 'px-6 py-3 text-base min-h-[44px]',
    lg: 'px-8 py-4 text-lg min-h-[52px]'
  };
  const disabledStyles = disabled || loading ? 'opacity-50 cursor-not-allowed' : '';
  const widthStyles = fullWidth ? 'w-full' : '';
  return <motion.button type={type} onClick={onClick} disabled={disabled || loading} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${widthStyles}`} whileTap={disabled || loading ? {} : {
    scale: 0.95
  }} data-id="element-150">
      {loading && <Loader2 size={18} className="animate-spin" data-id="element-151" />}
      {children}
    </motion.button>;
}